export function passionNameToKey(str) {
  switch (str) {
    case "beachWaterActivities":
      return "beach";
    case "mountainWinterSports":
      return "ski";
    case "liveMusicConcerts":
      return "music";
    case "wineBeerEnthusiast":
      return "culinary";
    case "spa":
      return "spa";
    case "localCultureExcursions":
      return "culture";
    default:
      return str;
  }
}
